import { getLineage } from 'features/evals3/api/evals3Api';

/** One eval's current graph, fetched once per tab session (the steps a filter can reach). */
const graphs = new Map();

export function loadEvalGraph(teamId, lineageId) {
  if (!lineageId) return Promise.resolve({ nodes: {} });
  const key = `${teamId}:${lineageId}`;
  if (!graphs.has(key)) {
    graphs.set(key, Promise.resolve(getLineage(teamId, lineageId))
      .then((d) => d?.current?.graph || { nodes: {} })
      .catch(() => { graphs.delete(key); return { nodes: {} }; }));
  }
  return graphs.get(key);
}

export function _resetEvalGraphCache() { graphs.clear(); }
